import { NgModule } from '@angular/core';
import { provideLazyLoad } from '@core/jss-utils';
import { BreadcrumbContainerComponent } from '@core/navigation-container/breadcrumb';

@NgModule({
  imports: [
    provideLazyLoad({
      Breadcrumb: BreadcrumbContainerComponent,
    }),
  ],
})
export class CoreNavigationLazyModule {}
